import gql from 'graphql-tag';

export const SUBMIT_CONDITION_MEET = gql`
  mutation ($input: MeetConditionCheckInput!) {
    submitCheckMeetCondition(input: $input) {
      status
      conditionFulfillingDeadline
      contactDepartmentPersonName
      contactDepartmentPersonEmail
      contactDepartmentPersonPhone
    }
  }
`;
